import BackButton from "../../../components/Buttons/BackButton";
import XsCont from "../../../components/containers/Xs";
import HeaderSignOut from "../../../components/headers/HeaderSignOut";
import { API_URL } from "../../../consts/ApiUrl";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Container, Typography, IconButton } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// ルックアッププラグインは本番未リリースのため、.env.* のフラグで環境ごとに表示を切り替える
const showLookupPlugin: boolean =
  process.env.REACT_APP_SHOW_LOOKUP_PLUGIN === "true";

const ManualDownloadPage: FC = () => {
  const navigate = useNavigate();
  const [version, setVersion] = useState<string>("1.0.0");
  const [downloadUrl, setDownloadUrl] = useState<string>("");
  const [lookupManualVersion, setLookupManualVersion] = useState<string>("");
  const [lookupManualUrl, setLookupManualUrl] = useState<string>("");

  useEffect(() => {
    const idToken: string = sessionStorage.getItem("idToken") || "";
    if (!idToken) {
      navigate("/signin?from=manual", { replace: true });
      return;
    }

    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      Authentication: idToken,
    };
    if (API_URL.DOWNLOAD_FILE.includes("ngrok-free.dev")) {
      headers["ngrok-skip-browser-warning"] = "true";
    }

    const fetchFileInfo = async () => {
      try {
        const response = await fetch(
          `${API_URL.DOWNLOAD_FILE}?file_type=manual`,
          {
            method: "GET",
            headers,
          }
        );
        if (!response.ok) {
          if (response.status === 401) {
            navigate("/signin?from=manual", { replace: true });
          } else {
            navigate("/error");
          }
          return;
        }
        const data = await response.json();
        const { url, version } = data.result;

        setVersion(version);
        setDownloadUrl(url);
      } catch (error) {
        console.error("エラー:", error);
        navigate("/error");
      }
    };

    // ルックアッププラグイン設定マニュアルは manual.zip とは別に配布する。
    // 取得できなくても manual.zip のダウンロードは使えるよう、失敗時は表示しないだけにする
    const fetchLookupManualInfo = async () => {
      try {
        const response = await fetch(
          `${API_URL.DOWNLOAD_FILE}?file_type=lookup-manual`,
          {
            method: "GET",
            headers,
          }
        );
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        const { url, version } = data.result;

        setLookupManualVersion(version);
        setLookupManualUrl(url);
      } catch (error) {
        console.error("エラー:", error);
      }
    };

    fetchFileInfo();
    if (showLookupPlugin) {
      fetchLookupManualInfo();
    }
  }, [navigate]);

  const handleDownload = (url: string) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      navigate("/error");
    }
  };

  const handleButtonClick = () => {
    navigate("/menu");
  };

  return (
    <>
      <HeaderSignOut />
      <Container maxWidth="lg">
        <Box mt={10} textAlign="center">
          <Typography variant="h4" gutterBottom>
            マニュアルダウンロード
          </Typography>
          <Typography variant="body1" color="textSecondary" mt={15}>
            V Callプラグイン マニュアル バージョン: {version}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={1}
            gap={1}
            ml={3}
          >
            <Typography variant="h6">manual.zip</Typography>
            <IconButton
              color="primary"
              onClick={() => handleDownload(downloadUrl)}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" color="textSecondary" mt={1}>
            （サービスサイト・サインアップ・プラグイン設定の 3 冊）
          </Typography>
          {showLookupPlugin && lookupManualUrl && (
            <>
              <Typography variant="body1" color="textSecondary" mt={5}>
                ルックアッププラグイン設定マニュアル バージョン:{" "}
                {lookupManualVersion}
              </Typography>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mt={1}
                gap={1}
                ml={3}
              >
                <Typography variant="h6">
                  ルックアッププラグイン設定マニュアル（PDF）
                </Typography>
                <IconButton
                  color="primary"
                  onClick={() => handleDownload(lookupManualUrl)}
                >
                  <DownloadIcon />
                </IconButton>
              </Box>
            </>
          )}
        </Box>
      </Container>
      <XsCont>
        <BackButton onClick={handleButtonClick} mt={15}>
          メニューに戻る
        </BackButton>
      </XsCont>
    </>
  );
};

export default ManualDownloadPage;
